module.exports = {"normal":"Обычный","elite":"Элитный","boss":"Босс","finalboss":"Последний босс","rare":""};